import progressComponent from './progressComponent'

export default {
    timout: null,
    install(Vue) {
        let component = Vue.extend(progressComponent);
        let loading = null
        let totalProgress = 0
        let completeProgress = 0

        window.progress = () => {}

        window.progress.init = () => {
            if (loading === null) {
                loading = new component({el: document.createElement('div')})
                document.body.appendChild(loading.$el)
            }
        }

        window.progress.show = (msg) => {
            window.progress.init()

            totalProgress++

            clearTimeout(this.timeout)

            if (msg != '' && msg != undefined) {
                loading.message = msg
            }

            loading.show = true

            setTimeout(() => {
                if (loading.show) {
                    loading.show = false
                    completeProgress = totalProgress
                }
            }, 60000)
        }

        window.progress.hide = (flag) => {
            completeProgress++

            if (completeProgress == totalProgress) {
                if (flag === true) {
                    loading.show = false
                } else {
                    this.timeout = setTimeout(() => {
                        loading.show = false
                    }, 300)
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/progress.js